var app = angular.module("leonardo");

var LevelBreadCrumb = function($scope, $state, $q, $timeout, parentObj, countryObj, PermissionService,
                               AuthDataService, LevelService) {

  $scope.permissionService = PermissionService;
  $scope.countryObj = countryObj;
  $scope.parentObj = parentObj;
  $scope.authDataService = AuthDataService;

  $scope.breadCrumb = [];

  $scope.initBreadCrumb = function () {
    var level_type_parent = $scope.parentObj ? ($scope.parentObj.level_type == 1 && $scope.countryObj.code.toLowerCase() == "ca" ? $scope.parentObj.level_type + 1 : $scope.parentObj.level_type) : 0;
    $scope.getLevelParent($scope.parentObj, []).then(function (parents){
      angular.forEach(parents, function (parent) {
        $scope.breadCrumb.push({id: parent.id, name: parent.name});
      });
      $scope.breadCrumb.push({name: $scope.getLevelsName({level_type: level_type_parent + 1})});
    });
  };

  $scope.getLevelParent = function (level, parents) {
    var defer = $q.defer();
    if (level) {
      parents.unshift(level);
      if (level.parents && level.parents.length > 0) {
        LevelService.get(level.parents[0], true).then(function (result) {
          $scope.getLevelParent(result, parents).then(function (results){
            defer.resolve(results);
          });
        });
      }
      else {
        defer.resolve(parents);
      }
    }
    else {
      defer.resolve(parents);
    }
    return defer.promise;
  };

  $scope.goToFolder = function(index) {
    var url = 'countries.levels';
    if (!$scope.breadCrumb[index-1]) {
      $state.go(url, {country: $scope.countryObj.id, parent: null});
    }
    else {
      $state.go(url, {country: $scope.countryObj.id, parent: $scope.breadCrumb[index-1].id});
    }
  };

  $scope.getClassButton = function(key) {
    if(!$scope.parentObj || (key === $scope.parentObj.id)) {
      return 'btn-go';
    }
    return 'btn-go-back-breadcrumb';
  };

  $scope.getLevelsName = function(level) {
    var label = 'level_' + level.level_type + '_label';
    return $scope.countryObj[label] + 's';
  };

  $timeout($scope.initBreadCrumb, 500);
};

app.controller('LevelBreadCrumb', ['$scope', '$state', '$q', '$timeout', 'parentObj', 'countryObj', 'PermissionService',
  'AuthDataService', 'LevelService', LevelBreadCrumb]);
